import { Stack, Typography, Tooltip } from '@mui/material';
import { useTheme, alpha } from '@mui/material/styles';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';

export type VisibilityMode = 'hidden_from_ai' | 'shared_with_ai';

interface Props {
  mode?: VisibilityMode;
}

const VisibilityBadge = ({ mode = 'hidden_from_ai' }: Props) => {
  const theme = useTheme();
  const isHidden = mode === 'hidden_from_ai';

  const accent = isHidden ? theme.palette.warning.main : theme.palette.success.main;
  const label = isHidden ? 'Hidden from AI' : 'Shared with AI';
  const tooltip = isHidden
    ? 'Visible to you only — never sent to the AI. Contains raw PII (names, SSN, addresses).'
    : 'This content is part of the AI session — the agent sees it. Anonymized/hash-only.';
  const Icon = isHidden ? EyeInvisibleOutlined : EyeOutlined;

  return (
    <Tooltip title={tooltip} placement="top" arrow>
      <Stack
        direction="row"
        spacing={0.625}
        alignItems="center"
        sx={{
          px: 0.875,
          py: 0.3125,
          borderRadius: 1,
          bgcolor: alpha(accent, 0.1),
          border: `1px solid ${alpha(accent, 0.26)}`,
        }}
      >
        <Icon style={{ fontSize: 11, color: accent }} />
        <Typography
          sx={{
            fontSize: '0.6875rem',
            fontWeight: 700,
            letterSpacing: 0.5,
            textTransform: 'uppercase',
            color: accent,
            lineHeight: 1,
          }}
        >
          {label}
        </Typography>
      </Stack>
    </Tooltip>
  );
};

export default VisibilityBadge;
